import { render } from "./SingleDay.vue?vue&type=template&id=93bf455c&scoped=true"
import script from "./SingleDay.vue?vue&type=script&lang=js"
export * from "./SingleDay.vue?vue&type=script&lang=js"

import "./SingleDay.vue?vue&type=style&index=0&id=93bf455c&scoped=true&lang=css"
import "./SingleDay.vue?vue&type=style&index=1&id=93bf455c&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93bf455c"]])

export default __exports__